export enum Branch {
	Cakovice = "Cakovice",
	Central = "Central",
	Petriny = "Petriny",
}

export type OutletBranch = Exclude<Branch, Branch.Central>;

export const outletBranchNameMap: Record<OutletBranch, string> = {
	[Branch.Cakovice]: "Čakovice",
	[Branch.Petriny]: "Petřiny",
};

export const branchNameMap: Record<Branch, string> = {
	[Branch.Central]: "Centrála",
	...outletBranchNameMap,
};

export const branchLongNameMap: Record<Branch, string> = {
	[Branch.Cakovice]: "Sladká dílna - Čakovice",
	[Branch.Central]: "Sladká dílna - centrála",
	[Branch.Petriny]: "Sladká dílna - Petřiny",
};
